import { Link } from '@inertiajs/react'
import { ArrowRight, Bot } from 'lucide-react'
import CheckoutLayout from '@/frontend/layouts/CheckoutLayout'
import { Button } from '@/components/ui/button'

export default function CheckoutIndex() {
  return (
    <CheckoutLayout>
      <div className="min-h-screen flex items-center justify-center px-4 py-28">
        <div className="w-full max-w-lg text-center">
          <Bot className="mx-auto h-14 w-14 text-sky-300" />
          <h1 className="mt-6 text-3xl font-bold text-white">Assinatura por colaborador</h1>
          <p className="mt-3 text-base text-slate-300">
            Escolha o colaborador digital antes de iniciar o checkout.
          </p>
          <Button asChild size="lg" className="mt-8 bg-white text-slate-950 hover:bg-slate-200">
            <Link href="/dashboard/digital_workers/new">
              Criar ou selecionar colaborador
              <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </CheckoutLayout>
  )
}
